import React from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import AppCard from '../../../../../components/ui/AppCard';
import localBGImage from '../../../../../assets/images/patterns/applyPolicy.png';
import apiClient from '../../../../../services/api-client';

export default function PendingApplicationPolicyDisplay({ applicationDetail }) {
  const history = useHistory();

  const deleteApplication = async (ID_Number) => {
    try {
      await apiClient
        .get("policy/track/" + ID_Number + "/delete")
        .then((response) => {
          if (response.data.status === "SUCCESS") {
            window.location.reload();
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  switch (applicationDetail.applicationStatus) {
    case "waiting-approval":
      return (
        <AppCard headerImg={localBGImage}>
          <div className="flex flex-col text-center justify-center py-6">
            <h3 className="text-xl font-bold mb-3">Your Policy is being reviewed</h3>
            <p className="text-sm text-base-content/70">
              <strong className="block text-base-content mb-1">We will be in touch in a moment</strong>
              We embrace operational excellence at all times, gained by our years of extensive experience
            </p>
          </div>
        </AppCard>
      );
    case "incomplete-application":
      return (
        <AppCard headerImg={localBGImage}>
          <div className="flex flex-col text-center justify-center py-6">
            <h3 className="text-xl font-bold mb-3 text-warning">
              You have not completed your policy application
            </h3>
            <p className="text-sm text-base-content/70 mb-2">
              <strong className="text-base-content">You can </strong>continue from where you left from and finish your application
            </p>
            <p className="text-sm text-error italic mb-4">
              Kindly finish this application or delete it to access more functionality
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-2">
              <Button
                className="w-full sm:w-auto"
                size="large"
                label={<strong>Continue Application</strong>}
                severity="warn"
                rounded
                outlined
                raised
                onClick={() => {
                  history.push("/manage-policy");
                }}
              />
              <Button
                className="w-full sm:w-auto"
                size="large"
                label="Delete Application"
                severity="danger"
                rounded
                raised
                onClick={() => {
                  deleteApplication(applicationDetail.mainMember.ID_Number);
                }}
              />
            </div>
          </div>
        </AppCard>
      );
    case "rejected-policy-application":
      return (
        <AppCard headerImg={localBGImage}>
          <div className="flex flex-col text-center justify-center py-6">
            <h3 className="text-xl font-bold mb-3 text-error">
              Your Policy might have concerns that need you to address them.
            </h3>
            <p className="text-sm text-base-content/70 mb-4">
              <strong className="block text-base-content mb-1">For the ones you love</strong>
              We embrace operational excellence at all times, gained by our years of extensive experience
            </p>
            <Button
              className="w-full sm:w-auto mx-auto"
              size="large"
              label={<strong>Contact Support</strong>}
              severity="warn"
              rounded
              outlined
              raised
              onClick={() => {
                history.push("/manage-policy");
              }}
            />
          </div>
        </AppCard>
      );
    default:
      return (
        <AppCard headerImg={localBGImage}>
          <div className="flex flex-col text-center justify-center py-6">
            <h3 className="text-xl font-bold mb-3">
              Your Policy application is being processed
            </h3>
            <p className="text-sm text-base-content/70">
              <strong className="block text-base-content mb-1">For the ones you love</strong>
              We embrace operational excellence at all times, gained by our years of extensive experience
            </p>
          </div>
        </AppCard>
      );
  }
}
